export interface IPaginatedSearchResult<T> {
  TotalCount: number;
  Resultset: T[];

  totalCount: number;
  resultset: T[];
}

export class PaginatedSearchResult<T> implements IPaginatedSearchResult<T> {
  TotalCount: number;
  Resultset: T[];

  totalCount: number;
  resultset: T[];

  constructor();
  constructor(obj: IPaginatedSearchResult<T>);
  constructor(obj?: IPaginatedSearchResult<T>) {
    this.TotalCount = obj?.TotalCount ?? 0;
    this.Resultset = obj?.Resultset ?? [];

    this.totalCount = obj?.totalCount ?? 0;
    this.resultset = obj?.resultset ?? [];
  }
}
